(function () {
  "use strict";

  catalogResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('trainerWebApp.resources')
    .factory('catalogResource', catalogResource);

  function catalogResource($resource, errorHandler) {

    var catalogResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/catalog/:catalogId/:entity');

    catalogResource.prototype.create = function create(resultCb, errorCb) {
      return catalogResource.save(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.load = function load(catalogId, resultCb, errorCb) {
      return catalogResource.get({catalogId: catalogId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.updateEmail = function load(catalogId, resultCb, errorCb) {
      return catalogResource.save({
        catalogId: catalogId,
        entity: 'updateEmail'
      }, null, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.doDelete = function deleteCatalog(catalogId, resultCb, errorCb) {
      return catalogResource['delete']({catalogId: catalogId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.update = function update(params, resultCb, errorCb) {
      return catalogResource.save({catalogId: params.id}, _.omit(params, 'id'), resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.getAddCoursesSetup = function getAddCoursesSetup(catalogId, resultCb, errorCb) {
      var obj = {catalogId: catalogId, entity: 'add-courses-setup'};
      return catalogResource.get(obj, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    catalogResource.prototype.addItems = function addItems(params, resultCb, errorCb) {
      var obj = {catalogId: params.catalogId, entity: 'course'};
      return catalogResource.save(obj, {itemIds: params.itemIds}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new catalogResource;
  }

})();
